// @flow

/**
 * Implementation based on https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
 *
 * Helper function that wraps your promise in order to make it cancelable so that async
 * callbacks are not executed unintentionally.
 */

export type CancelablePromise<T> = {|
  cancel: () => void,
  promise: Promise<T>,
|};

export default function makeCancelablePromise<T>(promise: Promise<T>): CancelablePromise<T> {
  let hasCanceled = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      (val) => (hasCanceled ? reject({ isCanceled: true }) : resolve(val)),
      (error) => (hasCanceled ? reject({ isCanceled: true }) : reject(error)),
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled = true;
    },
  };
}
